import actions from './actions';

const module = {
  namespaced: true,
  actions,
};

export default module;
